// ABOUTME: Resolves the data-analytics marker of a clicked element and parses its properties.
// ABOUTME: Disabled elements are skipped; malformed props still record the event without properties.

export function readAnalyticsTarget(
    target: EventTarget | null,
): { name: string; properties?: Record<string, unknown> } | null {
    if (!(target instanceof Element)) return null;
    const element = target.closest('[data-analytics]');
    if (!element) return null;
    if (element.matches(':disabled') || element.getAttribute('aria-disabled') === 'true') {
        return null;
    }
    const name = element.getAttribute('data-analytics')?.trim();
    if (!name) return null;
    const rawProps = element.getAttribute('data-analytics-props');
    if (!rawProps) return { name };
    try {
        const parsed: unknown = JSON.parse(rawProps);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
            return { name, properties: parsed as Record<string, unknown> };
        }
    } catch {
        // falls through to the warning below
    }
    console.warn(`user-analytics: ignoring malformed data-analytics-props on "${name}"`);
    return { name };
}
